import React from 'react';

import { JobTitleAutocomplete } from './job-title-autocomplete';

type InputProps = {
  jobTitle: ReduxFormFieldProps<string>;
  jobId: ReduxFormFieldProps<number | null>;
  orgId: number;
};

export const JobTitleAutocompleteReduxFormComponent = ({
  orgId,
  jobTitle: { input: jobTitleInput },
  jobId: { input: jobIdInput },
}: InputProps) => (
  <JobTitleAutocomplete
    orgId={orgId}
    jobTitle={jobTitleInput.value || ''}
    setJobTitle={jobTitleInput.onChange}
    jobId={jobIdInput.value || null}
    setJobId={jobIdInput.onChange}
  />
);
